import { render } from "./ConfigSysNetwork.vue?vue&type=template&id=bc46457c&scoped=true"
import script from "./ConfigSysNetwork.vue?vue&type=script&lang=js"
export * from "./ConfigSysNetwork.vue?vue&type=script&lang=js"

import "./ConfigSysNetwork.vue?vue&type=style&index=0&id=bc46457c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc46457c"]])

export default __exports__